export const INITIALISE_SAGE = gql`
    mutation InitialiseSage {
        initialiseSage
    }
`;
